
import FaceIcon from '@mui/icons-material/Face';
import Face4Icon from '@mui/icons-material/Face4';

import { Chip } from 'primereact/chip';

import { DEBUG, API_BASE_URL_UAT, API_BASE_URL, BOOK_LIST } from '../Utilities/constant';

export function addManagerList2MemberList(memberList, managerList) {
    const list = memberList.map(member => {
        //const assignServiceIdList = assignList.filter(assign => assign.memberId === member.id).map(assign => assign.serviceId);
        const managerServiceIdList = managerList.filter(manager => manager.memberId === member.id).map(manager => manager.serviceId);
        return {
            ...member,
            //assignServiceIdList: assignServiceIdList,
            managerServiceIdList: managerServiceIdList,
        };
    });
    //const member = list.find(member => member.id === 2);
    return list;
}

export function addAssignList2MemberList(memberList, assignList) {
    const list = memberList.map(member => {
        const assignServiceIdList = assignList.filter(assign => assign.memberId === member.id).map(assign => assign.serviceId);
        // const managerServiceIdList = managerList.filter(manager => manager.memberId === member.id).map(manager => manager.serviceId);
        return {
            ...member,
            assignServiceIdList: assignServiceIdList,
            // managerServiceIdList: managerServiceIdList,
        };
    });
    //const member = list.find(member => member.id === 2);
    return list;
}

export function addNumber2MemberList(memberList, assignList, managerList) {
    const list = memberList.map(member => {
        const assignServiceIdList = assignList.filter(assign => assign.memberId === member.id).map(assign => assign.serviceId);
        const managerServiceIdList = managerList.filter(manager => manager.memberId === member.id).map(manager => manager.serviceId);
        return {
            ...member,
            assignServiceIdList: assignServiceIdList,
            managerServiceIdList: managerServiceIdList,
        };
    });
    //const member = list.find(member => member.id === 2);
    return list;
}

export function updateManagerSupervisorList(username, list, serviceId, selectedMemberList) {
    const filteredList = list.filter(item => item.serviceId !== serviceId);
    const newList = selectedMemberList.map(member => { // ID, UserName, ServiceID, MemberID, CreationDateTimeHK, RevisionDateTimeHK, Valid
        return { username: username, serviceId: serviceId, memberId: member.id };
    });
    return [...filteredList, ...newList];
}

export function sortManagerList(axiosManagerList, axiosMemberList) {
    const newManagerList = axiosManagerList.map(manager => {
        const memberListItem = axiosMemberList.find(member => member.id === manager.memberId);
        return {
            ...manager,  // Spread all properties of the manager
            memberListItem: memberListItem
        };
    });
    return newManagerList.sort((a, b) => {    
        if (a.serviceId !== b.serviceId) {
            return a.serviceId - b.serviceId; // Ascending order for ServiceID
        }
        if (a.memberListItem.gender === b.memberListItem.gender) { // Order by gender (M before F, descending)                
            if (a.memberListItem.sort === b.memberListItem.sort) { // If genders are the same, order by sort (A < B < C)                    
                return a.memberListItem.chineseName.localeCompare(b.memberListItem.chineseName); // If sort is the same, order by chineseName (ascending)
            }
            return a.memberListItem.sort.localeCompare(b.memberListItem.sort); // Ascending order for sort
        }
        return a.memberListItem.gender === "F" ? 1 : -1; // M comes before F
    });
}

export function sortDistrictList(axiosDistrictList) {
    axiosDistrictList.sort((a, b) => {            
        if (a.sort === b.sort) { // If genders are the same, order by sort (A < B < C)                    
            return a.district.localeCompare(b.district); // If sort is the same, order by chineseName (ascending)
        }
        return a.sort.localeCompare(b.sort); // Ascending order for sort
    });
}

export function sortMemberList(axiosMemberList) {
    axiosMemberList.sort((a, b) => {            
        if (a.gender === b.gender) { // Order by gender (M before F, descending)                
            if (a.sort === b.sort) { // If genders are the same, order by sort (A < B < C)                    
                return a.chineseName.localeCompare(b.chineseName); // If sort is the same, order by chineseName (ascending)
            }
            return a.sort.localeCompare(b.sort); // Ascending order for sort
        }
        return a.gender === "F" ? 1 : -1; // M comes before F
    });
}

export function getChip(member, handleChipClick) {
    const desc = DEBUG ? ` ${member.sort}:${member.chineseName} ID${member.id}` : ` ${member.sort}:${member.chineseName}`;
    return <span> <Chip icon={getFace(member.gender)} label={desc} style={{ margin: '5px' }} onClick={() => handleChipClick(member)}/> </span>
}

export function getFace(gender) {
    switch(gender) {
        case 'M':
            return <FaceIcon style={{ color: 'black' }}/>;
        case 'F':
            return <Face4Icon style={{ color: 'red' }} />;
    }
}

export function getServiceListItem(serviceList, serviceID) {
    return serviceList[serviceID];
}